import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

interface LazyImageProps {
  src: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
  width?: string | number;
  height?: string | number;
  effect?: 'blur' | 'opacity' | 'black-and-white';
  threshold?: number;
  eager?: boolean; // For above-the-fold images
  placeholderSrc?: string;
}

/**
 * LazyImage component with blur effect and performance optimization
 * Use eager={true} for above-the-fold images that should load immediately
 */
const LazyImage: React.FC<LazyImageProps> = ({
  src,
  alt,
  className = '',
  style = {},
  width,
  height,
  effect = 'blur',
  threshold = 100,
  eager = false,
  placeholderSrc
}) => {
  // If eager loading is requested (for above-the-fold), use regular img tag
  if (eager) {
    return (
      <img
        src={src}
        alt={alt}
        className={className}
        style={style}
        width={width}
        height={height}
        loading="eager"
      />
    );
  }

  // Otherwise, use lazy loading
  return (
    <LazyLoadImage
      src={src}
      alt={alt}
      className={className}
      style={style}
      width={width}
      height={height}
      effect={effect}
      threshold={threshold}
      placeholderSrc={placeholderSrc}
      wrapperClassName="lazy-image-wrapper"
    />
  );
};

export default LazyImage;
